import type { ClassificationResponse } from "../types/classification"
import type { SummarizationResponse } from "../types/summarization"

type Props = {
  result: ClassificationResponse | SummarizationResponse
}

export default function TextResult({ result }: Props) {
  return (
    <div className="mt-6"> 
      <div className="mb-6"> 
        <p>{String(result.prediction)}</p>
      </div>
    </div>
  )
}